import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-6 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          <Link
            to="/"
            className="px-4 py-2 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all flex-shrink-0"
          >
            全部
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm whitespace-nowrap cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-all flex-shrink-0 border border-background-200"
            >
              <span className="w-4 h-4 flex items-center justify-center mr-1.5 inline-flex">
                <i className={`${cat.icon} text-xs`}></i>
              </span>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}